var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.5C16.7991 0.5 21.5 5.20085 21.5 11C21.5 16.7991 16.7991 21.5 11 21.5C5.20085 21.5 0.5 16.7991 0.5 11C0.5 5.20085 5.20085 0.5 11 0.5ZM11 1.55C5.7815 1.55 1.55 5.7815 1.55 11C1.55 16.2185 5.7815 20.45 11 20.45C16.2185 20.45 20.45 16.2185 20.45 11C20.45 5.7815 16.2185 1.55 11 1.55Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 11C19.25 15.5563 15.5563 19.25 11 19.25C6.44365 19.25 2.75 15.5563 2.75 11C2.75 6.44365 6.44365 2.75 11 2.75C15.5563 2.75 19.25 6.44365 19.25 11ZM15.5335 8.53666C15.7471 8.31103 15.7373 7.95501 15.5117 7.74147C15.286 7.52793 14.93 7.53773 14.7165 7.76336L9.44515 13.333L7.28233 11.0621C7.06808 10.8371 6.71203 10.8284 6.48707 11.0427C6.26211 11.2569 6.25343 11.613 6.46767 11.8379L9.0391 14.5379C9.14548 14.6496 9.29306 14.7128 9.44731 14.7125C9.60156 14.7123 9.74894 14.6487 9.85497 14.5367L15.5335 8.53666Z",
    fill: "#569BC1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/Pass.89232a48.svg";
export { ForwardRef as ReactComponent };